import { render } from "./ProductionCagesTable.vue?vue&type=template&id=da6d7ae4&ts=true&lang=pug"
import script from "./ProductionCagesTable.vue?vue&type=script&lang=ts"
export * from "./ProductionCagesTable.vue?vue&type=script&lang=ts"

import "./ProductionCagesTable.vue?vue&type=style&index=0&id=da6d7ae4&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__